// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

const useAreProductsLoading = () => {
    return useAppSelector(state => Object.entries(state.data.products.isLoading).length > 0);
};

export default useAreProductsLoading;
